import { FaFacebookF } from 'react-icons/fa'
import styles from './FacebookButton.module.css'
export default function FacebookButton() {
  return (
    <div className={styles.facebookLogin}>
      <button title='Não publicaremos nada em seu perfil'>Entrar utilizando Facebook <FaFacebookF /></button>
    </div>
  )
}